import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import DatePickerButton from './DatePickerButton';

const Datepicker = ({ value, onChange }) => (
  <DatePicker
    customInput={<DatePickerButton />}
    dateFormat="MMM dd, yyyy"
    selected={value}
    onChange={onChange}
  />
);

Datepicker.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Datepicker;
